// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@components";
import type { State } from "@store/reducers";
import { getEmployeeAbsenceNotificationModal } from "@modules/shared/selectors/employee-absences";
import type { EmployeeAbsenceNotificationModal } from "@modules/shared/reducer/employee-absences/types";
import actionCreators from "@modules/shared/actionCreator";

type PropsFromState = $Exact<{
  modal: EmployeeAbsenceNotificationModal,
}>;

type PropsFromDispatch = $Exact<{
  toggleModal: typeof actionCreators.ToggleEmployeeAbsenceNotificationModal,
}>;

type Props = $Exact<{
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class AbsenceDetailsNotificationContentModal extends React.Component<Props> {
  closeModal = () => {
    this.props.toggleModal({
      visible: false,
      notification: null,
    });
  };

  render() {
    return (
      <Modal className="min-modal-width">
        <ModalHeader toggle={this.closeModal}>
          {this.props.t("ABSENCE_NOTIFICATION_NUMBER", {
            id: (this.props.modal.notification || {}).id,
          })}
        </ModalHeader>
        <ModalBody>
          <iframe
            title="absence-notification-content"
            className="w-100 border-0"
            style={{ minHeight: 500 }}
            srcDoc={(this.props.modal.notification || {}).content}
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.closeModal}>
            {this.props.t("CANCEL")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  modal: getEmployeeAbsenceNotificationModal(state),
});

const mapDispatchToProps: PropsFromDispatch = {
  toggleModal: actionCreators.ToggleEmployeeAbsenceNotificationModal,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(AbsenceDetailsNotificationContentModal);
